import Cookie from 'js-cookie';

type BeforeLanguageChangeListener = () => void;

const LANGUAGE_COOKIE_DAYS = 30;

const beforeLanguageChangeListeners = new Set<BeforeLanguageChangeListener>();

export const onBeforeLanguageChange = (listener: BeforeLanguageChangeListener) => {
  beforeLanguageChangeListeners.add(listener);
  return () => {
    beforeLanguageChangeListeners.delete(listener);
  };
};

export const changeLanguage = (code: string) => {
  beforeLanguageChangeListeners.forEach((listener) => listener());
  Cookie.set('language', code, {
    expires: LANGUAGE_COOKIE_DAYS,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
  window.location.reload();
};
